import React from "react";
import ReactTable from "react-table";
import { Checkbox, FormControlLabel, IconButton, TextField, Tooltip } from "@material-ui/core";
import Refresh from "@material-ui/icons/Refresh";
import Button from "../../components/CustomButtons/Button";
import { formatUTCtoPST } from "../../shared/utility";

const PaymentReportsList = props => {
    const {
        data,
        total,
        page,
        pageSize,
        loading,
        paymentIdFilter,
        setPaymentIdFilter,
        showVoided,
        setShowVoided,
        loadEntries,
        openEntry,
        regenerateEntry,
        regeneratingId
    } = props;

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{ width: 220 }}>
                    <TextField
                        label="Payment ID"
                        value={paymentIdFilter}
                        onChange={e => setPaymentIdFilter(e.target.value.replace(/\D/g, ""))}
                        fullWidth
                    />
                </div>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showVoided}
                            onChange={e => {
                                const checked = e.target.checked;
                                setShowVoided(checked);
                                loadEntries({ page: 0, showVoided: checked });
                            }}
                            color="primary"
                        />
                    }
                    label="Show Voided"
                />
                <Button
                    color="primary"
                    onClick={() => loadEntries({ page: 0 })}
                >
                    FILTER
                </Button>
                <Button
                    onClick={() => {
                        setPaymentIdFilter("");
                        setShowVoided(false);
                        loadEntries({ page: 0, paymentId: "", showVoided: false });
                    }}
                >
                    CLEAR
                </Button>
            </div>
            <div className="table-adjust2">
                <ReactTable
                    manual
                    filterable={false}
                    loading={loading}
                    className="-striped -highlight"
                    showPaginationTop
                    showPaginationBottom
                    resizable={true}
                    page={page}
                    pages={Math.max(1, Math.ceil(total / pageSize))}
                    pageSize={pageSize}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onPageChange={nextPage => loadEntries({ page: nextPage })}
                    onPageSizeChange={(nextPageSize, nextPage) => loadEntries({ page: nextPage, pageSize: nextPageSize })}
                    data={data.map(d => {
                        const dataObj = d.data || {};
                        return {
                            id: d.id,
                            payment_id: d.payment_id,
                            invoice_id: dataObj.invoice_id || "",
                            invoice_number: dataObj.invoice_number || "",
                            rs_id: dataObj.rs_id || "",
                            payment_voided: d.payment_voided ? "Yes" : "No",
                            user: d.created_by_name || "",
                            timestamp: formatUTCtoPST(d.timestamp),
                            actions: (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Tooltip title="Open saved report">
                                        <IconButton onClick={() => openEntry(d)}>
                                            <i className="fa fa-eye"></i>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Regenerate report">
                                        <span>
                                            <IconButton
                                                disabled={regeneratingId === d.id}
                                                onClick={() => regenerateEntry(d)}
                                            >
                                                <Refresh />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>
                            )
                        };
                    })}
                    columns={[
                        {
                            Header: "ID",
                            accessor: "id",
                            maxWidth: 70
                        },
                        {
                            Header: "Payment ID",
                            accessor: "payment_id",
                            maxWidth: 110
                        },
                        {
                            Header: "Invoice ID",
                            accessor: "invoice_id",
                            maxWidth: 110
                        },
                        {
                            Header: "Invoice #",
                            accessor: "invoice_number",
                            maxWidth: 120
                        },
                        {
                            Header: "RS ID",
                            accessor: "rs_id",
                            maxWidth: 90
                        },
                        {
                            Header: "Payment Voided",
                            accessor: "payment_voided",
                            maxWidth: 140
                        },
                        {
                            Header: "Generated By",
                            accessor: "user"
                        },
                        {
                            Header: "Generated At",
                            accessor: "timestamp"
                        },
                        {
                            Header: "Actions",
                            accessor: "actions",
                            sortable: false,
                            maxWidth: 140
                        }
                    ]}
                />
            </div>
        </>
    );
};

export default PaymentReportsList;
